module.exports = __webpack_public_path__ + "static/img/chest.c7b4bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/chest.png
// module id = HTXX
// module chunks = 216